// Cross-document ready rejects when the browser skips a transition. Install
// before first rendering (classic head script), including the outgoing page.
// No global rejection filter: an unrelated error remains observable.
const observedTransitions = new WeakSet<ViewTransition>();

function observeTransition(transition: ViewTransition | null | undefined): void {
  if (!transition || observedTransitions.has(transition)) return;
  observedTransitions.add(transition);
  void transition.ready.catch((error: unknown) => {
    if (error instanceof DOMException && error.name === 'AbortError') return;
    reportError(error);
  });
}

function observePageTransition(event: Event): void {
  observeTransition((event as Event & { viewTransition?: ViewTransition | null }).viewTransition);
}

window.addEventListener('pageswap', observePageTransition);
window.addEventListener('pagereveal', observePageTransition);
// An incoming transition can already exist while the head is being parsed,
// before pagereveal, and be superseded by an immediate navigation/media change.
observeTransition(document.activeViewTransition);
